.container {
  height: 200px;

  > span {
    width: 100%;
  }
}
